import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import product from '@/components/commerceProduct/commerceProduct'
import ProductsCarousel from '@/components/productsCarousel/productsCarousel'

@Component({
  components: {
    product,
    ProductsCarousel
  }
})
export default class CommerceCategory extends Vue {
  @Prop({ default: () => null }) category;

  get getProducts () {
    const products = (this.category as any).products
    
    products.sort((a: any, b: any) => {
      return a.ordinal - b.ordinal
    })
    
    return products
  }

  get getRoute() {
    let response = null;
    if(this.category && this.category.id) {
      response = {
        name: 'commerceCategory',
        params: {
          category_id: this.category.id
        }
      };
    }
    return response;
  }

}
